export class Location {
  public lat: number
  public lng: number
  
  constructor() {
    this.lat = 45.981719;
    this.lng = 4.719358;
  }
}
